export default __webpack_public_path__ + "static/media/Sarabun-SemiBold.398aadea.ttf";